module.exports = __webpack_public_path__ + "img/Singapore.7dca493f.png";